import { api } from "../APIClient";
import { ACTION_TYPE } from "reducers/actionType";
import ERROR_TYPE from "utils/errors";
const ENDPOINT_PATH = "/service/stage/2/process";

export const getEligibility = (userSubjects, recommendations_input_hash) => {
  return dispatch => {
    dispatch({
      type: ACTION_TYPE.eligibilityFetch.begin,
      data: { eligibility: null, loading: true, error: null }
    });
    return api
      .post(
        ENDPOINT_PATH +
          (recommendations_input_hash
            ? "?recommendations_input_hash=" + recommendations_input_hash
            : ""),
        { subjects: Object.values(userSubjects) }
      )
      .then(response => {
        dispatch({
          type: ACTION_TYPE.eligibilityFetch.success,
          data: { eligibility: response.data, loading: false }
        });
        const { eligibility_input_hash } = response.data;
        dispatch({
          type: ACTION_TYPE.hash,
          data: { eligibility_input_hash: eligibility_input_hash }
        });
      })
      .catch(error => {
        // dispatch({
        //   type: ACTION_TYPE.eligibilityFetch.failure,
        //   data: { error, loading: false, eligibility: null }
        // });
        const { response } = error;
        let errorType = null;
        let errors = null;

        if (!response) {
          errorType = ERROR_TYPE.network;
        } else {
          const { status } = response;
          if (400 <= status && status < 500) {
            errorType = ERROR_TYPE.client;
          } else {
            errorType = ERROR_TYPE.server;
          }
          errors = response.data.errors;
        }

        dispatch({
          type: ACTION_TYPE.eligibilityFetch.failure,
          data: {
            loading: false,
            error: {
              errorType: errorType,
              errors: errors
            }
          }
        });
      });
  };
};
